// import { env } from "lib/env"
import mapboxgl from "mapbox-gl"
import {
  AGGREGATED_MUNICIPALITY_LAYER_NAME,
  BLOCKGROUP_LAYER_NAME,
  BLOCKGROUP_OUTLINE_HOVER_LAYER_NAME,
  BLOCKGROUP_OUTLINE_LAYER_NAME,
  BLOCKGROUP_SOURCE_ZOOM,
  BLOCKGROUP_ZOOM,
  DEFAULT_ACTIVE_FACET,
  DEFAULT_MUNICIPALITY_ACTIVE_FACET,
  MUNICIPALITY_LAYER_NAME,
  MUNICIPALITY_OUTLINE_LAYER_NAME,
  MUNICIPALITY_SOURCE_ZOOM,
  SourceNames,
} from "app/constants"
import { getFillExpression, getOpacityExpression } from "app/utils/paint_utils"
import { Facet } from "data/facets"
import { MUNICIPALITY_ZOOM } from "app/constants"
import { getTileServerUrlFormatter } from "app/utils/map_utils"

export default function addNationalExplorerMapLayers(params: {
  map: mapboxgl.Map
  isSatellite: boolean
  facets: Facet[]
  cityId: string
}) {
  const { map, isSatellite, facets } = params

  const defaultMunicipalityFacet = facets.find(
    (f) => f.field.type == "Municipality" && f.field.field === DEFAULT_MUNICIPALITY_ACTIVE_FACET
  )!

  const defaultBlockgroupFacet = facets.find(
    (f) => f.field.type == "Block Group" && f.field.field === DEFAULT_ACTIVE_FACET
  )!

  const beforePoi = isSatellite ? undefined : "poi-label"
  const formatTileserverUrl = getTileServerUrlFormatter("national")

  /**
   * in the sources, minzoom and maxzoom need to match those of the tileset. if the maxzoom isn't set
   * the tiles won't overzoom correctly.
   */
  map.addSource(SourceNames.MUNICIPALITY, {
    type: "vector",
    tiles: [formatTileserverUrl("national_municipalities")],
    minzoom: 2,
    maxzoom: MUNICIPALITY_SOURCE_ZOOM,
  })

  map.addSource(SourceNames.BLOCKGROUP, {
    type: "vector",
    tiles: [formatTileserverUrl("national_blockgroups")],
    minzoom: 9,
    maxzoom: BLOCKGROUP_SOURCE_ZOOM,
  })

  map.addLayer(
    {
      source: SourceNames.MUNICIPALITY,
      "source-layer": "data",
      id: AGGREGATED_MUNICIPALITY_LAYER_NAME,
      type: "fill",
      minzoom: 2,
      maxzoom: MUNICIPALITY_ZOOM,
      paint: {
        "fill-color": "#33966D",
      },
    },
    beforePoi
  )

  map.addLayer(
    {
      source: SourceNames.MUNICIPALITY,
      "source-layer": "data",
      id: MUNICIPALITY_LAYER_NAME,
      type: "fill",
      minzoom: MUNICIPALITY_ZOOM,
      maxzoom: BLOCKGROUP_ZOOM,
      paint: {
        "fill-color": getFillExpression(defaultMunicipalityFacet),
        "fill-opacity": getOpacityExpression(defaultMunicipalityFacet),
      },
    },
    beforePoi
  )

  map.addLayer(
    {
      source: SourceNames.BLOCKGROUP,
      "source-layer": "data",
      id: BLOCKGROUP_LAYER_NAME,
      type: "fill",
      minzoom: BLOCKGROUP_ZOOM,
      paint: {
        "fill-color": getFillExpression(defaultBlockgroupFacet),
        "fill-opacity": getOpacityExpression(defaultBlockgroupFacet),
      },
    },
    beforePoi
  )

  map.addLayer(
    {
      source: SourceNames.BLOCKGROUP,
      "source-layer": "data",
      id: BLOCKGROUP_OUTLINE_LAYER_NAME,
      type: "line",
      minzoom: BLOCKGROUP_ZOOM,
    },
    beforePoi
  )

  map.addLayer(
    {
      source: SourceNames.MUNICIPALITY,
      "source-layer": "data",
      id: MUNICIPALITY_OUTLINE_LAYER_NAME,
      type: "line",
      minzoom: MUNICIPALITY_ZOOM,
    },
    beforePoi
  )

  map.addLayer(
    {
      source: SourceNames.BLOCKGROUP,
      "source-layer": "data",
      id: BLOCKGROUP_OUTLINE_HOVER_LAYER_NAME,
      type: "line",
      minzoom: BLOCKGROUP_ZOOM,
    },
    beforePoi
  )
}
